<template>
    <app-layout>
        <template #header>
            <div>
                <div>
                    <nav class="sm:hidden" aria-label="Back">
                        <inertia-link :href="route('sepa.edit', {sepa: sepa})" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                            <ChevronLeftIcon class="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                            Zurück
                        </inertia-link>
                    </nav>
                    <nav class="hidden sm:flex" aria-label="Breadcrumb">
                        <ol class="flex items-center space-x-4">
                            <li>
                                <div>
                                    <inertia-link :href="route('farm', {farm: sepa.farm})" class="text-sm font-medium text-gray-500 hover:text-gray-700">
                                        {{ sepa.farm.name }}</inertia-link>
                                </div>
                            </li>
                            <li>
                                <div class="flex items-center">
                                    <ChevronRightIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                    <inertia-link :href="route('farm.sepa', {farm: sepa.farm})" aria-current="page" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">SEPA-Mandatslisten</inertia-link>
                                </div>
                            </li>
                            <li>
                                <div class="flex items-center">
                                    <ChevronRightIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                    <inertia-link :href="route('sepa.edit', {sepa: sepa})" aria-current="page" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">
                                        {{ sepa.name }}
                                    </inertia-link>
                                </div>
                            </li>
                        </ol>
                    </nav>
                </div>
                <div class="mt-2 md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
                            Überweiser
                        </h2>
                    </div>
                </div>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="flex flex-col">
                        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                    <input v-model="search" type="text" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md w-full" placeholder="Suche" />
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead class="bg-gray-50">
                                        <tr>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Name
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Kundennummer
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Preis
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Text
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(transferrer, transferrerIdx) in transferrers.filter(item => { for(x of ['name', 'kdnr', 'text']) {if(item[x].toLowerCase().includes(search.toLowerCase())) return true} return false})" :key="transferrer.id" :class="transferrerIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                                            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                {{ transferrer.name }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {{ transferrer.kdnr }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(transferrer.preis) }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {{ transferrer.text }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-4">
                    <h3 class="text-lg leading-6 font-medium text-gray-900">
                        Summen
                    </h3>
                    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                        <div v-for="item in stats" :key="item.name" class="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6">
                            <dt class="text-sm font-medium text-gray-500 truncate">
                                {{ item.name }}
                            </dt>
                            <dd class="mt-1 text-3xl font-semibold text-gray-900">
                                {{ item.stat }}
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import JetApplicationLogo from "@/Jetstream/ApplicationLogo";
import JetDialogModal from "@/Jetstream/DialogModal";
import JetInput from "@/Jetstream/Input";
import JetLabel from "@/Jetstream/Label";
import JetInputError from "@/Jetstream/InputError";
import Editor from "@/Pages/Email/Editor";
import {PlusIcon, ChevronLeftIcon, ChevronRightIcon} from '@heroicons/vue/solid'
import { JSEncrypt } from 'jsencrypt'
import Button from "@/Jetstream/Button";
import Label from "@/Jetstream/Label";

export default {
    name: "ListEdit",
    components: {
        Label,
        Button,
        Editor,
        JetApplicationLogo,
        JetDialogModal,
        JetInput,
        JetInputError,
        JetLabel,
        AppLayout,
        PlusIcon,
        ChevronLeftIcon,
        ChevronRightIcon,
    },
    props: ['sepa', 'transferrers', 'sum', 'sum_transferrers'],
    data() {
        return {
            search: '',
            stats: [
                {
                    name: 'Gesamtsumme',
                    stat: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.sum),
                },
                {
                    name: 'davon überwiesen',
                    stat: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.sum_transferrers),
                },
                {
                    name: 'davon abgebucht',
                    stat: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.sum - this.sum_transferrers),
                }
            ]
        }
    },
    methods: {
    }
}
</script>
